export function sectionUnitKey(articleSlug: string, sectionId: string): string {
  return `${articleSlug}::section::${sectionId}`
}
